import { TemplateFieldsIProps } from "~/entity/Template";

import { templateHiddenFields } from "./options";

export const formaterData = (data: TemplateFieldsIProps) => {
  const { "Сеть X": netX, ...datas } = data;
  const result: TemplateFieldsIProps = {};

  for (const category in datas) {
    if (data.hasOwnProperty(category)) {
      result[category] = data[category].filter((item) => {
        if (templateHiddenFields[category]) {
          return !templateHiddenFields[category].includes(
            `${item.comment} - \{${item.field}\}`,
          );
        }
        return true;
      });
    }
  }
  return result;
};
